import { getAssetByContentType } from './utils';

type Props = {
	contentType: string | null;
};

const RightHandSideV2 = ({ contentType }: Props) => {
	const Asset = getAssetByContentType(contentType);

	return <Asset />;
};

export default RightHandSideV2;
